import React from 'react';
const comparisons = [{
  sin: '"Hay que meterle más ganas"',
  con: 'Rombo Ofensivo + cambio estratégico planificado'
}, {
  sin: 'Improvisás quién va al área',
  con: 'Ejecutan la variante ensayada el jueves'
}, {
  sin: 'Siempre el mismo discurso',
  con: 'Discurso Táctico de 90 segundos exactos'
}];
const features = ['Scouting Express — 10 estilos de rival y su antídoto en 5 min', 'Tablero de Comando — Decisiones predefinidas por marcador', '20 Jugadas de Pizarrón — Córners, laterales y tiros libres con diagramas', 'Psicología de Banco — 5 tipos de discurso listos para cada momento'];
export function EliteSection() {
  return <section className="w-full bg-[#001a0d] py-10 px-4" data-id="element-34">
      <div className="max-w-2xl mx-auto" data-id="element-35">
        <div className="text-center mb-6" data-id="element-36">
          <h2 className="text-xl sm:text-3xl font-black text-white mb-1" data-id="element-37">
            📋 ¿Qué agrega El Manual del DT Ganador?
          </h2>
          <p className="text-gray-300 text-xs sm:text-sm" data-id="element-38">
            Ya tenés el material para la semana. Esto resuelve el sábado.
          </p>
        </div>

        {/* Before / After */}
        <div className="space-y-2 mb-8" data-id="element-39">
          {comparisons.map((c, i) => <div key={i} className="grid grid-cols-2 gap-2" data-id="element-40">
              <div className="bg-gray-900/50 border border-gray-700/50 rounded-lg p-2.5 sm:p-3" data-id="element-41">
                <span className="text-[#FF8A80] text-[10px] sm:text-xs font-bold block mb-0.5" data-id="element-42">
                  ❌ Sin el Manual
                </span>
                <span className="text-gray-400 text-xs sm:text-sm leading-snug" data-id="element-43">
                  {c.sin}
                </span>
              </div>
              <div className="bg-[#00C853]/5 border border-[#00C853]/30 rounded-lg p-2.5 sm:p-3" data-id="element-44">
                <span className="text-[#00C853] text-[10px] sm:text-xs font-bold block mb-0.5" data-id="element-45">
                  ✅ Con el Manual
                </span>
                <span className="text-white text-xs sm:text-sm leading-snug" data-id="element-46">
                  {c.con}
                </span>
              </div>
            </div>)}
        </div>

        {/* Features */}
        <h3 className="text-base sm:text-lg font-black text-white text-center mb-4" data-id="element-47">
          EL MANUAL INCLUYE:
        </h3>
        <div className="space-y-2" data-id="element-48">
          {features.map((f, i) => <div key={i} className="flex items-start gap-2 bg-black/40 border border-[#00C853]/15 rounded-lg px-3 py-2.5" data-id="element-49">
              <span className="text-[#00C853] font-bold text-xs mt-0.5 flex-shrink-0" data-id="element-50">
                ✅
              </span>
              <span className="text-gray-200 text-xs sm:text-sm leading-snug" data-id="element-51">
                {f}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}